import { render, staticRenderFns } from "./product_inside_list.vue?vue&type=template&id=50f7baea&scoped=true&"
import script from "./product_inside_list.vue?vue&type=script&lang=js&"
export * from "./product_inside_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f7baea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f7baea')) {
      api.createRecord('50f7baea', component.options)
    } else {
      api.reload('50f7baea', component.options)
    }
    module.hot.accept("./product_inside_list.vue?vue&type=template&id=50f7baea&scoped=true&", function () {
      api.rerender('50f7baea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/inside_list/product_inside_list.vue"
export default component.exports